import { render } from "./ProjectsWidget.vue?vue&type=template&id=0583ba65"
import script from "./ProjectsWidget.vue?vue&type=script&lang=js"
export * from "./ProjectsWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__